import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button } from '@praktio/common-ui';

import { resetLearnerModule, updateLearnerLoading } from '../../ducks/learner';
import { RootState } from '../../ducks/store';

import './ReviewRetake.scss';

interface IProps {
  courseId: string;
  module?: IModule;
  onClick: () => void;
}

const ReviewRetake: FC<IProps> = ({ courseId, module, onClick }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading } = useSelector((state: RootState) => {
    const { learner } = state;
    const { loading } = learner;
    return {
      loading,
    };
  });

  const [retakeClicked, setRetakeClicked] = useState(false);
  const { _id, disableRetake, completedOverride } = module || {};

  useEffect(() => {
    if (loading) {
      dispatch(updateLearnerLoading(false));
    }
  }, [dispatch, loading]);

  return (
    <div className="ReviewRetake d-flex justify-content-center align-items-center h-100 w-100">
      <div className="ReviewRetake-modal">
        <div className="ReviewRetake-title">Would you like to review or retake this module?</div>
        <div className="ReviewRetake-text">
          You've already completed this module. Would you like to review your completed lessons or
          retake the module from the beginning?
        </div>
        <div className="ReviewRetake-button-container d-flex justify-content-center">
          <Button
            disabled={!!completedOverride}
            onClick={onClick}
            tooltip={
              completedOverride
                ? 'Review is unavailable for modules manually set as complete.'
                : undefined
            }
          >
            REVIEW
          </Button>
          <Button
            disabled={disableRetake || retakeClicked}
            showSpinner={retakeClicked}
            onClick={() => {
              if (_id && !disableRetake) {
                setRetakeClicked(true);
                (dispatch(resetLearnerModule({ courseId, moduleId: _id, navigate })) as any).then(
                  () => {
                    onClick();
                  },
                );
              }
            }}
          >
            RETAKE
          </Button>
        </div>
        <div className="ReviewRetake-footer d-flex">
          <span className="ReviewRetake-footer-icon material-icons-outlined">info</span>
          <div className="ReviewRetake-footer-text">
            Reviewing or retaking this module will not affect your course completion percentage or
            the availability of subsequent modules that require completion of this module.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewRetake;
